import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
  inject
} from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { v4 as uuidv4 } from 'uuid';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import isEqual from 'lodash/isEqual';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { tableFieldsForDM } from 'src/app/STORE/selectors/services.selector';
import { takeUntil } from 'rxjs/operators';
import * as propertyActions from 'src/app/STORE/actions/propertypane.actions';
import { DatePipe } from '@angular/common';
import { getFieldsForTable } from 'src/app/STORE/actions/services.actions';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { RegexPatternConstants } from 'src/app/base/regex-pattern.constants';
import { picklist, propertiesValues } from 'src/app/STORE/selectors/propertypane.selector';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { deleteImpMail } from 'src/app/STORE/actions/mailinfo.actions';
import { DMConstants } from 'src/app/pages/designs/data-model/data-model.component';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'vb-vs-export-prop',
  templateUrl: './vs-export-prop.component.html',
  styleUrls: ['./vs-export-prop.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VsExportPropComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class VsExportPropComponent implements OnInit, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private store = inject(Store);
  private loader = inject(AppLoaderService);
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);
  private baseService = inject(HttpBaseService);
  private appGlobalService = inject(AppGlobalService);
  private datePipe = inject(DatePipe);
  private util = inject(UtilService);

  @Input() element: any;
  @Input() disableField = false;
  @Input() formData: any;
  @Input() fieldIdMap: any = null;
  @Input() searchTerm = null;
  selected: string[] = [];
  exports: any = [];
  fieldResp: any[] = [];
  resCame = false;
  syncCame = false;
  expsCloneCopy: any = [];
  subFieldsArray: any[] = [];
  showLoader = false;
  searchableFieldOps: any = [];
  allFields: any[] = [];
  netFields: any[] = [];
  currentPickList: any;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  source: any[] = [];
  fromSave = false;
  targetBackup: any[] = [];
  target: any[] = [];
  srcFileTypes = [
    {
      name: 'Google Sheet',
      value: 'google_sheet'
    },
    {
      name: 'CSV',
      value: 'csv'
    },
    {
      name: 'Excel',
      value: 'excel'
    }
  ];
  csvDelimiterOptions = [
    {
      name: 'comma (,)',
      value: 'comma'
    },
    {
      name: 'semicolon (;)',
      value: 'semicolon'
    },
    {
      name: 'tab (\t)',
      value: 'tab'
    },
    {
      name: 'space ( )',
      value: 'space'
    },
    {
      name: 'pipe (|)',
      value: 'pipe'
    }
  ];
  showPickList = false;
  selectedPL: any[];
  pickList: any;
  currentExp: any = null;
  dateFormatOps: any = [];
  datetimeForOps: any = [];
  numForOptions: any = [];
  tableIdMap = new Map();
  @Output() public onTemplateChange = new EventEmitter();
  destroy$: Subject<boolean> = new Subject<boolean>();

  get model() {
    return this.modelValue;
  }

  referringFields() {
    let referringFields: any = [];
    referringFields = [...this.fieldResp.filter((fld) => fld.f_type === 'Lookup')];
    if (referringFields.length === 0) {
      this.getPickUpList(null, false, null, null);
      this.showLoader = false;
    } else {
      this.showLoader = true;
      for (let i = 0; i < referringFields.length; i++) {
        let referringTableId;
        const index = this.allFields.findIndex((field) => {
          return field.sid === referringFields[i].sid;
        });
        if (index > -1) {
          this.allFields.splice(index, 1);
        }
        const respIndex = this.fieldResp.findIndex((field) => {
          return field.sid === referringFields[i].sid;
        });
        if (respIndex > -1) {
          this.fieldResp.splice(respIndex, 1);
        }
        referringTableId = referringFields[i].f_lookupTo;
        if (i === referringFields.length - 1) {
          this.getPickUpList(referringTableId, true, referringFields[i], 'end');
        } else {
          this.getPickUpList(referringTableId, true, referringFields[i], 'start');
        }
      }
    }
  }

  writeValue(value: any): void {
    this.modelValue = value;
    this.setValues(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setValues(value) {
    if (value) {
      try {
        const exps = JSON.parse(value);
        this.exports = exps.map((exp) => {
          return exp;
        });

        this.expsCloneCopy = cloneDeep(this.exports);
        window.dispatchEvent(new Event('resize'));
      } catch (e) {
        console.error(e);
      }
    }
  }
  getPickUpList(sid, execute, field, position) {
    if (execute) {
      const subFieldName = field.name;
      let lookupFieldsArray;
      if (this.tableIdMap.has(sid)) {
        this.subFieldsArray.push({
          name: subFieldName,
          f_tableId: sid
        });
        lookupFieldsArray = this.allFields
          .filter((fld) => fld.subField === this.tableIdMap.get(sid))
          .map((fld) => {
            return {
              sid: fld.sid,
              name: fld.name,
              subField: subFieldName
            };
          });
        this.allFields = [...this.allFields, ...lookupFieldsArray];
        if (position === 'end') {
          this.allFields = [...this.allFields.filter((fld) => fld.name !== 'Sid')];
          this.fieldResp = [...this.allFields];
          this.showLoader = false;
          lookupFieldsArray = [];
        }
      } else if (sid) {
        this.tableIdMap.set(sid, subFieldName);
        this.baseService.get(ApiConstants.getDatamodelTableData, { sid: sid }).subscribe({
          next: (data: any) => {
            try {
              if (data.t_lookupFields) {
                const fldids = data.t_lookupFields.split(',');
                const lookupFieldsArr = fldids.map((id) => {
                  return {
                    sid: id,
                    name: this.fieldIdMap[id],
                    subField: subFieldName
                  };
                });
                this.allFields = [...this.allFields, ...lookupFieldsArr];
                if (this.tableIdMap.has(sid)) {
                  for (let i = 0; i < this.subFieldsArray.length; i++) {
                    const subArr = this.allFields.filter((fld) => fld.subField === this.subFieldsArray[i]);
                    if (sid === this.subFieldsArray[i].f_tableId) {
                      lookupFieldsArray = this.allFields
                        .filter((fld) => fld.subField === this.tableIdMap.get(sid))
                        .map((fld) => {
                          return {
                            sid: fld.sid,
                            name: fld.name,
                            subField: this.subFieldsArray[i].name
                          };
                        });
                      this.allFields = [...this.allFields, ...lookupFieldsArray];
                    }
                  }
                }
              }
              if (position === 'end') {
                this.allFields = [...this.allFields.filter((fld) => fld.name !== 'Sid')];
                this.fieldResp = [...this.allFields];
                this.showLoader = false;
                lookupFieldsArray = [];
                this.tableIdMap.clear();
                this.subFieldsArray = [];
              }
            } catch (e) {
              console.error(e);
            }
          },
          error: (error: any) => {
            this.showLoader = false;
          }
        });
      } else {
        this.showLoader = false;
      }
    }
    // else {
    //   this.exportAddObject();
    // }
  }

  getExpName(index) {
    let expNameAfterValidation = this.formData.name;
    if (this.formData.name.length > 55) {
      const result = this.formData.name.match(/.{1,55}/g) ?? [];
      expNameAfterValidation = result[0];
    }
    const expName = `${expNameAfterValidation} export ${index}`;
    const expProp = this.exports.find((ex: any) => ex.name.toLowerCase() === expName.toLowerCase());
    if (expProp) {
      return this.getExpName(index + 1);
    }
    return expName;
  }
  stopPropagation(event) {
    event.stopPropagation();
  }

  addexports() {
    const id = uuidv4();
    const expObj = {
      sid: id,
      name: this.getExpName(this.exports.length + 1),
      fields: this.allFields.map((obj) => {
        return { sid: obj.sid, subField: obj?.subField };
      }),
      notifyMail: false,
      fileTypes: ['csv'],
      roles: ['all'],
      filters: [],
      persistenceType: 'ANALYTICAL'
    };
    this.selected = [...this.selected, id];
    this.exports = [...this.exports, expObj];
    const i = this.exports.length;
    setTimeout(() => {
      $(`#expname-${i - 1}`).focus();
    }, 100);
  }

  delExp(i) {
    this.confirmationDialogService.confirm({
      message: 'Are you sure you want to Delete the export?',
      accept: () => {
        if (i > -1) {
          if (this.exports[i].mailTemplateId) {
            this.store.dispatch(
              deleteImpMail({
                apiConstants: ApiConstants.deleteImpMail,
                ids: { ids: this.exports[i].mailTemplateId }
              })
            );
          }
          const templateId = this.exports[i].sid;
          const templateName = this.exports[i].name;
          this.exports.splice(i, 1);
          this.modelValue = JSON.stringify(this.exports);
          this.expsCloneCopy = cloneDeep(this.exports);
          this.onTemplateChange.emit({
            templateId: templateId,
            templateName: templateName,
            action: 'delete'
          });
          this.onChange(this.modelValue);
        }
      },
      reject: () => {
        /* empty */
      }
    });
  }

  setValueOnChanges(event, exp, action?) {
    if (exp.name) {
      delete exp.err;
      // exp.fileTypes = [exp.fileTypes];
      this.expsCloneCopy = cloneDeep(this.exports);
      // this.expsCloneCopy = this.exports.filter(exp => exp.name);
      this.modelValue = JSON.stringify(this.expsCloneCopy);
      this.onTemplateChange.emit({
        templateId: exp.sid,
        templateName: exp.name,
        action: action ? action : 'update'
      });
      this.onChange(this.modelValue);
    }
  }

  onNameChange(event, exp) {
    if (!exp.name) {
      this.handleEmptyName(exp);
      return;
    }

    const validationResult = this.validateExportName(exp);
    if (!validationResult.isValid) {
      this.revertToBackupName(exp);
      return;
    }

    this.saveNameChange(event, exp);
  }

  private validateExportName(exp): { isValid: boolean } {
    const myRe = RegexPatternConstants.alphanumericName;
    const array = myRe.exec(exp.name);
    if (!array) {
      this.showMessage('error', this.translate.instant('ALPHANUMEREIC_CHARACTERS_ALLOWED'));
      return { isValid: false };
    }

    const duplicateIndex = this.exports.findIndex(
      (ex) => ex.sid !== exp.sid && ex.name.toLowerCase() === exp.name.toLowerCase()
    );
    if (duplicateIndex > -1) {
      this.showMessage('error', 'Export Name should be unique');
      return { isValid: false };
    }

    return { isValid: true };
  }

  private revertToBackupName(exp) {
    const backupIndex = this.expsCloneCopy.findIndex((ex) => ex.sid === exp.sid);
    if (this.expsCloneCopy[backupIndex]?.name) {
      const items = [...this.exports];
      items[backupIndex].name = this.expsCloneCopy[backupIndex].name;
      this.exports = [...items];
    }
  }

  private saveNameChange(event, exp) {
    const backupIndex = this.expsCloneCopy.findIndex((ex: any) => ex.sid === exp.sid);
    const action = this.expsCloneCopy[backupIndex] ? undefined : 'create';
    this.setValueOnChanges(event, exp, action);
  }

  private handleEmptyName(exp) {
    this.showMessage('error', 'Export Name is required');
    const backupIndex = this.expsCloneCopy.findIndex((i) => i.sid === exp.sid);
    if (backupIndex > -1 && this.expsCloneCopy[backupIndex].name) {
      const items = [...this.exports];
      items[backupIndex].name = this.expsCloneCopy[backupIndex].name;
      this.exports = [...items];
    } else {
      exp.err = true;
      this.updateexportsArr(exp);
    }
  }

  updateexportsArr(exp) {
    const updexports = this.exports.map((data) => {
      return data.sid === exp.sid ? exp : data;
    });
    this.exports = [...updexports];
  }

  onNotifyMailChange(event, exp) {
    if (exp.notifyMail) {
      exp.mailTemplateId = '';
    } else if (exp.mailTemplateId) {
      this.store.dispatch(
        deleteImpMail({
          apiConstants: ApiConstants.deleteImpMail,
          ids: { ids: exp.mailTemplateId }
        })
      );
    }
    this.updateexportsArr(exp);
    this.setValueOnChanges(event, exp);
  }

  onMailChanges(mailid, exp) {
    if (mailid) {
      exp.mailTemplateId = mailid;
      this.updateexportsArr(exp);
      this.setValueOnChanges(null, exp);
    }
  }

  handlefileTypeChange(event, exp) {
    if (exp.fileTypes.includes('csv')) {
      exp.csvDelimiter = 'comma';
    } else {
      exp.csvDelimiter = '';
    }
    this.updateexportsArr(exp);
    this.setValueOnChanges(event, exp);
  }

  increDecBatchSz(exp, operator) {
    switch (operator) {
      case '+':
        exp.batchSize += 10;
        break;
      case '-':
        exp.batchSize -= 10;
        break;
    }
    this.updateexportsArr(exp);
    this.setValueOnChanges(event, exp);
  }

  onbatchSzChange(event, exp) {
    if (exp.batchSize < 50) {
      exp.batchSize = 50;
      this.showMessage('error', `${exp.name} - Batch Size should not be less than 50`);
    } else if (exp.batchSize > 300) {
      exp.batchSize = 300;
      this.showMessage('error', `${exp.name} - Batch Size should not be greater than 300`);
    }
    this.updateexportsArr(exp);
    this.setValueOnChanges(event, exp);
  }

  onSearhableFldChanges(exp) {
    this.setValueOnChanges(null, exp);
  }
  onSearhableFldChangesOnRemove(event, exp) {
    this.setValueOnChanges(null, exp);
  }

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }

  togglePickList(event?: any, exp?: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      this.setValueToPickList(exp.fields);
      this.source = this.allFields
        .filter((fld) => !this.target.find((f) => f.sid === fld.sid))
        .map((obj) => {
          return { sid: obj.sid, searchValue: `${obj.name}`, subField: obj?.subField };
        });
      this.targetBackup = [...this.target];
      this.currentExp = exp;
    } else {
      this.target = [];
      this.source = [];
      this.selectedPL = [];
    }
    this.showPickList = !this.showPickList;
  }

  setValueToPickList(value) {
    this.selectedPL = [];
    this.target = [];
    if (value.length > 0) {
      this.target = value.map((e) => {
        return {
          ...e,
          allowEdit: true,
          searchValue: `${this.fieldIdMap[e.sid]} ${e.name ? e.name : ''}`,
          subField: e?.subField,
          name: e?.name
        };
      });
      this.selectedPL = [...value];
      this.source = this.allFields
        .filter((fld) => !this.target.find((f) => f.sid === fld.sid))
        .map((obj) => {
          return { sid: obj.sid, searchValue: `${obj.name}`, subField: obj?.subField };
        });
    } else {
      this.source = this.allFields.map((obj) => {
        return { sid: obj.sid, searchValue: `${obj.name}`, subField: obj?.subField };
      });
      this.target = [];
    }
    if (!this.target) {
      this.target = [];
    }
  }

  onMoveToTarget(event) {
    let items = [...this.target];
    items = items.map((item) => {
      item = { ...item, ...{ allowEdit: true } };
      return item;
    });
    this.target = [...items];
    this.source = [...this.source];
    this.selectedPL = [...this.target];
  }

  onMoveToSource(event) {
    const items = this.source.map((item) => {
      const obj = { ...item };
      delete obj.allowEdit;
      if (Object.prototype.hasOwnProperty.call(item, 'name')) {
        delete obj.name;
      }
      if (Object.prototype.hasOwnProperty.call(item, 'edit')) {
        delete obj.edit;
      }
      if (Object.prototype.hasOwnProperty.call(item, 'altName')) {
        delete obj.altName;
      }
      return obj;
    });
    this.source = [...items];
    this.target = [...this.target];
    this.selectedPL = [...this.target];
  }

  onTargetReorder(event) {
    console.log(event);
  }

  savePicklist() {
    this.selectedPL = this.target.map((ele) => {
      const obj = { ...ele };
      delete obj.allowEdit;
      if (Object.prototype.hasOwnProperty.call(ele, 'edit')) {
        delete obj.edit;
      }
      // if (ele.hasOwnProperty('name')) {
      //   delete obj.name;
      // }
      if (Object.prototype.hasOwnProperty.call(ele, 'searchValue')) {
        delete obj.searchValue;
      }
      return obj;
    });
    this.currentExp = { ...this.currentExp, ...{ fields: this.selectedPL } };
    this.updateexportsArr(this.currentExp);
    this.setValueOnChanges(null, this.currentExp);
    this.fromSave = true;
    this.togglePickList(null, null);
    this.currentExp = null;
  }

  closeDialog(event) {
    this.showPickList = false;
    if (!isEqual(this.target, this.targetBackup) && !this.fromSave) {
      this.confirmationDialogService.confirm({
        message: 'You have unsaved changes. Are you sure you want to leave this page?',
        accept: () => {
          this.target = [...this.targetBackup];
          this.showPickList = false;
        },
        reject: () => {
          this.showPickList = true;
        }
      });
    }
    this.fromSave = false;
  }

  editFieldName(property) {
    property.edit = true;
    property.name = '';
    let items = [...this.target];
    items = items.map((item) => {
      return (property?.subField && item.sid === property.sid && item.subField === property.sid) ||
        (!property?.subField && item.sid === property.sid)
        ? property
        : item;
    });
    this.target = [...items];
  }

  saveFieldName(property) {
    // property.edit = false;
    const dupAltNme = this.target.find(
      (fld) => fld.sid !== property.sid && fld.name && fld.name.toLowerCase() === property.name.toLowerCase()
    );
    if (dupAltNme) {
      // property.err = true;
      this.showMessage(
        'error',
        `${property.name} is already used as an alternate name. Alternate Name should be unique`
      );
      return;
    }
    // property.err = false;
    property.edit = false;

    let items = [...this.target];
    items = items.map((item) => {
      return (property?.subField && item.sid === property.sid && item.subField === property.sid) ||
        (!property?.subField && item.sid === property.sid)
        ? { ...property, ...{ searchValue: `${this.fieldIdMap[property.sid]} ${property.name ? property.name : ''}` } }
        : item;
    });
    this.target = [...items];
  }

  cancelEdit(property) {
    property.edit = false;
    const savedProp = this.selectedPL.find((pl) => pl.sid === property.sid);
    property.name = this.fieldIdMap[property.sid];
    // delete property.altName;
    // property.altName = savedProp ? savedProp.altName : '';
    let items = [...this.target];
    items = items.map((item) => {
      return (property?.subField && item.sid === property.sid && item.subField === property.sid) ||
        (!property?.subField && item.sid === property.sid)
        ? property
        : item;
    });
    this.target = [...items];
  }

  ontargetSelect(event) {
    /* empty */
  }

  ngOnInit(): void {
    // picklist
    // this.pickupOptions.push({
    //   name:'hello',
    //   value:'hello'
    // })
    this.subFieldsArray = [];
    this.tableIdMap.clear();
    const pickListSub = this.store
      .select(picklist)
      .pipe(takeUntil(this.destroy$))
      .subscribe((list: any) => {
        this.currentPickList = list;
      });
    let tableId;
    //  this.loader.show();
    // this.showLoader = true;
    let tableType = this.formData.t_type;
    //  let fieldResp;
    this.store
      .select(tableFieldsForDM)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res) {
          if (res.length > 0) {
            const filterFields = res.filter(
              (fld) =>
                fld.f_type !== 'Image Carousel' &&
                fld.f_type !== 'File Attachments' &&
                fld.f_type !== 'Complex Datatype'
            );
            /* let filterOps;
          if (tableType===DMConstants.TRANS_ANALY) {
            filterOps = filterFields.filter(fld => (fld.f_hasAnalyticalSync));
          } else {
            filterOps = cloneDeep(filterFields);
          } */
            this.searchableFieldOps = [
              ...filterFields.map((fld) => {
                return { label: fld.name, value: { sid: fld.sid } };
              })
            ];
            this.allFields = res.filter(
              (fld) =>
                fld.f_type !== 'Image Carousel' &&
                fld.f_type !== 'File Attachments' &&
                fld.f_type !== 'Complex Datatype'
            );
            tableId = this.allFields[0].f_tableId;
            this.fieldResp = [...this.allFields];
            if (tableType === DMConstants.TRANS_ANALY) {
              if (this.fieldResp[0].f_tableId) {
                this.allFields = [
                  ...this.fieldResp
                    .filter((fld) => fld.f_hasAnalyticalSync)
                    .map((fld) => {
                      return { sid: fld.sid, name: fld.name };
                    })
                ];
                this.fieldResp = [...this.fieldResp.filter((fld) => fld.f_hasAnalyticalSync)];
                this.searchableFieldOps = [
                  ...filterFields
                    .filter((fld) => fld.f_hasAnalyticalSync)
                    .map((fld) => {
                      return { label: fld.name, value: { sid: fld.sid } };
                    })
                ];
              }

              //  this.loader.hide();
              // }
            } else {
              this.allFields = [
                ...this.allFields.map((fld) => {
                  return { sid: fld.sid, name: fld.name };
                })
              ];
            }
            // let referringFields=[... this.fieldResp.filter(fld => (fld.complexDataTypeId || fld.lookupTo))]
            // if(referringFields.length > 0){
            //   this.loader.show();
            // }
            // else{
            //   this.loader.hide();
            // }
            this.referringFields();
            // let fieldArray=this.allFields.map(obj => { return { sid: obj.sid,label:obj.name } });
            // complexDataTypeId
            // this.loader.hide();
          } else {
            this.showLoader = false;
          }
        }
      });
    if (this.appGlobalService.get('transactionDb') === 'NoSQL') {
      const tableSub = this.store
        .select(propertiesValues)
        .pipe(takeUntil(this.destroy$))
        .subscribe((tableData: any) => {
          if (tableData && tableData.t_type) {
            tableType = tableData.t_type;
            if (tableData?.sid && tableData?.sid === tableId && tableData.t_type === DMConstants.TRANS_ANALY) {
              if (this.fieldResp[0].f_tableId) {
                const subFields = this.allFields.filter((fld) => fld.subField);
                if (subFields.length === 0) {
                  this.allFields = [
                    ...this.fieldResp
                      .filter((fld) => fld.f_hasAnalyticalSync)
                      .map((fld) => {
                        return { sid: fld.sid, name: fld.name };
                      })
                  ];
                  this.fieldResp = [...this.fieldResp.filter((fld) => fld.f_hasAnalyticalSync)];
                }
              }
            }
          }
        });
    }
    const values = this.util.dateFormats;
    this.dateFormatOps = values.map((val) => {
      return {
        label: `${val} (${this.datePipe.transform(new Date(), val)})`,
        value: val
      };
    });
    const tvalues = ['h:mm:ss a', 'h:mm a', 'h:mm:ss a z', 'h:mm:ss a zzzz', 'H:mm', 'H:mm:ss'];
    this.datetimeForOps = tvalues.map((val) => {
      return {
        label: `${val} (${this.datePipe.transform(new Date(), val)})`,
        value: val
      };
    });
    this.numForOptions = [
      {
        label: '9.999,00',
        value: {
          displayLabel: '9.999,00',
          thousandSeparator: '.',
          decimalSeperator: ','
        }
      },
      {
        label: '9 999,00',
        value: {
          displayLabel: '9 999,00',
          thousandSeparator: '',
          decimalSeperator: ','
        }
      },
      {
        label: '9,999.00',
        value: {
          displayLabel: '9,999.00',
          thousandSeparator: ',',
          decimalSeperator: '.'
        }
      }
    ];
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}


